import { DirectorTransaction } from "./DirectorDataModels";

export interface FounderDetailDataModel {
  fullName: string;
  emailId: string;
  designation: string;
  contactNumber?: number;
  address?: string;
  dateOfBirth?: string;
  nationality?: string;
  linkedInProfile?: string;
  twitterHandle?: string;
  id?: number;
  isEdit?: boolean;
  shouldShowDialog?: boolean;
  isSelected?: boolean;
}

export enum SpocType {
  KMP = "KMP",
  SPOC = "SPOC",
}

export interface SpocDetailModel {
  type: SpocType;
  name: string;
  email: string;
  phone?: string;
}

export interface CompanyDetailsPostModel {
  id?: string | number;
  nameOfTheCompany: string;
  dippCertificateNumber: string;
  cinNumber: string;
  typeOfTheCompany: string;
  companyCurrency: string;
  dateOfIncorporation: string;
  corporateOfficeAddress: string;
  businessDescription: string;
  companyEmailId: string;
  companyWebsite: string;
  companyLogoPath: string;
  doingBusinessAs: string;
  industry: string[];
  category: string[];
  nic: string;
  founders: FounderDetailDataModel[];
  // directors: DirectorDetailModel[];
  equityAuthorizedShareCapital?: number;
  preferenceAuthorizedShareCapital?: number;
  equityPaidUpShareCapital?: number;
  preferencePaidUpShareCapital?: number;
  valuationDetails: ValuationDataModel[];
  splitFilter: boolean;
}

export interface DirectorDetailModel {
  id?: number;
  fullName: string;
  typeOfDirector: string;
  emailId: string;
  din: string;
  address?: string;
  contactNumber?: string;
  nationality: string;
  dateOfBirth?: string;
  countryOfResidence?: string;
  dateOfAppointement?: string;
  dateOfBoardResoluitonForAppointement?: string;
  isEdit?: boolean;
  shouldShowDialog?: boolean;
  isSelected?: boolean;
  isResigned?: boolean;
  resignationDate?: string;
  tags?: string[];
  transactions?: DirectorTransaction[];
}

export interface CompanyDetailsRequestModel {
  id: string;
  nameOfTheCompany: string;
  dippCertificateNumber: string;
  cinNumber: string;
  typeOfTheCompany: string;
  companyCurrency: string;
  doingBusinessAs: string;
  dateOfIncorporation: string;
  corporateOfficeAddress: string;
  companyEmailId: string;
  categoryDropdownValues: string[];
  industryDropdownValues: string[];
  business: string[];
  industry: string[];
  companyWebsite: string;
  companyLogoPath: string;
  nic: string;
  subscribersOfMemorandum: string;
  founders: FounderDetailDataModel[];
  directors: DirectorDetailDataModel[];
  showFaq: boolean;
  isEsopOnlyCompany: boolean;
  isDownloadEnabled: boolean;
  equityAuthorizedShareCapital?: number;
  preferenceAuthorizedShareCapital?: number;
  equityPaidUpShareCapital?: number;
  preferencePaidUpShareCapital?: number;
  valuationDetails: ValuationDataModel[];
}

export interface DirectorDetailDataModel {
  address?: string;
  contactNumber?: string;
  countryOfResidence?: string;
  dateOfAppointement?: string;
  dateOfBirth?: string;
  dateOfBoardResoluitonForAppointement?: string;
  dateOfBoardResoluitonForCessation?: string;
  dateOfCessation?: string;
  din: string;
  emailId: string;
  fatherName?: string;
  fullName: string;
  gender?: string;
  id?: number;
  motherName?: string;
  nationality: string;
  nominationBy?: string;
  occupation?: string;
  spouseName?: string;
  typeOfDirector: string;
  isResigned?: boolean;
  tags?: string[];
  transactions?: DirectorTransaction[];
  investorNominees?: string[];
}

export interface DropDownModel {
  selectedCategoryValues?: string[];
  selectedIndustryValues?: string[];
  industryDropdownValues: string[];
  categoryDropdownValues: string[];
}

export interface ValuationDataModel {
  id?: string;
  name: string;
  dateOfValuation: string;
  typeOfValuation: string;
  valuationPps: number;
  valuationMethodology?: string;
  bookValue: number;
  valuer?: string;
  valuerRgNumber?: string;
  valuationReportBase64: string;
  udinNumber: string;
  fileType: string;
}

export interface CompanyConfig {
  companyId: string;
  fdbCalculation?: string;
  numberRound?: string;
  isPrivate?: boolean;
  splitFilter?: boolean;
  preferences?: {
    hideTransactionCards?: boolean;
    hideSystemGeneratedReports?: boolean;
  };
}
